import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

/**
 * Route guard for `/business/*` routes.
 *
 * Shows a spinner only while Firebase auth resolves.
 * BusinessLayout is eagerly imported so it renders immediately after auth,
 * and each lazy page is caught by BusinessLayout's own Suspense boundary.
 */
const ProtectedRoute: React.FC = () => {
  const { currentUser, loading, isBusiness } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  if (!isBusiness) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
